<script lang="ts" setup>
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';

const props = withDefaults(
  defineProps<{
    headerHeight?: number;
    additionalHeight?: number;
  }>(),
  {
    headerHeight: 64,
    additionalHeight: 0,
  },
);

const isNextLayout = useIsNextLayout();

const height = `calc(100vh - ${props.headerHeight + props.additionalHeight}px)`;
</script>

<template>
  <div class="section-wrapper" :class="{ 'is-next-layout': isNextLayout }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.section-wrapper {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  padding-bottom: 36px; // メニュー折りたたみボタンに被らないため

  height: v-bind(height);
  overflow-y: auto;
  overflow-x: hidden;

  background: white;

  &.is-next-layout {
    height: auto;
    overflow: visible;
    padding-bottom: 64px; // メニュー折りたたみボタンに被らないため
  }
}
</style>
